import {EntityState} from '@datorama/akita';
import {ToneInterface} from '@interfaces/tone-interface';

export interface TonesState extends EntityState<ToneInterface> {}

export function createTonesInitialState(): Partial<TonesState> {
  return {};
}
